module.exports = __webpack_public_path__ + "static/media/02.6d8b124f.png";